<template>
    <div class="box-content relative text-black px-[8px] h-fit bg-gray-100 overflow-hidden">
        <div>
            <h3 class="absolute text-sm md:text-lg top-2 left-4 md:top-10 md:left-10 font-semibold uppercase text-prime-color font-sans">Academic</h3>
            <div class="flex gap-[8px] md:gap-3 flex-col md:flex-row mt-4 md:mt-0 justify-center">
                <h3 data-aos="fade-left" data-aos-duration="1000" class="mb-0 h-fit text-6xl lg:text-8xl text-prime-color text-center"><i>Academic</i></h3>
                <h3 data-aos="fade-right" data-aos-duration="1000" class="mb-0 h-fit text-6xl lg:text-8xl text-prime-color text-center"><i>Programs</i></h3>
            </div>
            <p data-aos="fade-in" data-aos-duration="2000" class="pt-[12p   x] md:pt-5 pb-3 md:pr-4 font-medium uppercase text-center text-base md:text-xl text-prime-color font-sans">Các chương trình học tại HUET</p>
            <div class="text-xl text-justify text-black md:w-11/12 lg:w-3/4 mx-auto px-[10px] grid grid-cols-1 lg:grid-cols-5 gap-[8px] md:gap-6">
                <img v-viewer src="@/assets/img/about/about-6.jpg" class="image_hover lg:col-span-2 max-h-[300px] sm:max-h-[330px] md:max-h-[300px] lg:h-fit w-full object-cover object-center rounded-tl-[160px] rounded-br-[160px]">
                <div class="h-fit lg:col-span-3">
                    <p class="">
                        Với phương châm cùng suy nghĩ, cùng hành động để đạt được những thành công ở hiện tại và trong tương lai, 
                        Khoa Kỹ thuật và Công nghệ – Đại học Huế (HUET) sẽ trang bị cho các bạn hành trang vững vàng từ kiến thức, 
                        kĩ năng sống và nhân cách để cùng với bạn đi đến bến bờ tri thức. HUET luôn thấu hiểu một nền giáo dục tốt 
                        chính là nền tảng để tạo dựng nên những con người thành công trong tương lai. Trình độ văn hoá cao, bản 
                        lĩnh mạnh mẽ, trí tuệ sáng suốt cùng những hiểu biết sâu rộng, các bạn chính là những nhân tố góp phần làm 
                        cho xã hội này trở nên văn minh, hạnh phúc và nhân ái hơn.
                    </p>
                    <div class="md:float-right text-black text-lg md:text-xl font-normal md:px-6 flex w-fit mx-auto cursor-pointer gap-[6px] hover:gap-0 transition-all duration-300">
                        <svg class="my-auto" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="transform: ;msFilter:;"><path d="m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z"></path></svg>
                        <p class="text-black hover:text-black font-semibold mb-0" @click="()=>{this.$router.push({name: 'user.training'})}">Tìm hiểu ngay</p>
                    </div>
                </div>
            </div>
            <p class="pt-[12px] pb-1 md:pr-4 font-medium uppercase text-center text-base md:text-xl text-prime-color font-sans">Một số ngành học của HUET</p>
        </div>
        <div v-if="loading" class="px-[12px] md:px-[60px] lg:px-[100px]">
            <vue-horizontal-list :items="entry" :options="options">
                <template v-slot:nav-next class="bg-transparent">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path></svg>
                    </div>
                </template>
                <template v-slot:nav-prev>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg>
                    </div>
                </template>
                <template v-slot:default="{ item }">
                    <div class="item relative">
                        <div class="bg-white w-full h-[280px] border-[1px] border-black hover:border-orange-400 relative rounded-2xl overflow-hidden course-card transition-all duration-300">
                            <img @error="replaceBrokenImage" :src="$addPrefix(item.image)" loading="lazy" class="w-full h-[250px] object-cover object-center cursor-pointer">
                            <div class="bg-white h-fit px-[8px] py-3 md:px-3 flex flex-col rounded-tl-2xl absolute bottom-0 left-0 right-0 course-content">
                                <h5 class="mb-0 text-xl font-semibold truncate capitalize text-black">{{ item.name }}</h5>
                                <h6 class="mb-0 text-lg font-medium capitalize text-black">{{ item.type }}</h6>
                                <p class="w-full line-clamp-3 mt-2 pt-1 border-t-[1px] border-white" v-html="item.description"></p>
                                <p @click="redirectToDetail(item._id)" class="mb-0 pr-2 mt-2 text-right hover:text-prime-color cursor-pointer font-semibold">Tìm hiểu ngay</p>
                                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg"><path></path></svg>
                            </div>
                        </div>
                    </div>
                </template>
            </vue-horizontal-list>
        </div>
        <Loading v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Loading from '@/components/loading'
import VueHorizontalList from 'vue-horizontal-list';

export default {
    components: {
        Loading, VueHorizontalList
    },
    data() {
        return {
            entry: [],
            loading: false,
            uniCourses: [],
            afterUniCourses: [],
            transferUniCourses: [],
            shortCourses: [],
            options: {
                responsive: [
                { end: 576, size: 1 },
                { start: 576, end: 768, size: 2 },
                { start: 768, end: 992, size: 3 },
                { start: 992, end: 1280, size: 4 },
                { size: 5 },
                ],
                list: {
                windowed: 1280,
                padding: 24,
                },
                position: {
                start: 1,
                },
                autoplay: { play: true, repeat: true, speed: 4000 },
            },
        };
    },
    methods: {
        ...mapActions('course', ['GetCourseList']),
        async getEntry() {
            let respone = await this.GetCourseList()
            for (let index in respone.data) {
                switch (respone.data[index].type) {
                    case 'Hệ đại học':
                        this.uniCourses.push(respone.data[index]);
                        break;
                    case 'Hệ cao học':
                        this.afterUniCourses.push(respone.data[index]);
                        break;
                    case 'Liên thông đại học':
                        this.transferUniCourses.push(respone.data[index]);
                        break;
                    case 'Khóa học ngắn hạn':
                        this.shortCourses.push(respone.data[index]);
                        break;
                }
            }
            this.entry = this.uniCourses.concat(this.afterUniCourses).concat(this.transferUniCourses).concat(this.shortCourses)
            this.loading = true
        },
        redirectToDetail(id) {
            this.$router.push({path: '/training/detail/' + id})
        },
		replaceBrokenImage(event) {
			event.target.src = require("@/assets/img/error/no-image.png");
		},
    },
    created() {
        this.loading = false
        this.getEntry()
    },
}
</script>
<style lang="scss">
.course-card{
    .course-content {
        color: white;
        transition: all ease-in 300ms;
        transform: translateY(120px);
    }
}
.course-card:hover {
    .course-content {
        transform: translateY(0px);
        color: black;
        .border-white {
            border-color: rgb(194, 194, 194) !important;
        }
    }
}
</style>
<style scoped>
.card__arc {
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 99%;
  right: 0;      
  z-index: 1;
}
.card__arc path {
  fill: white;
  /* d: path("m 40 80 c 22 0 40 -22 40 -40 v 40 z"); */
  d: path("m 20 40 c 11 0 20 -11 20 -20 v 20 z");
}
</style>